<template>
  <div class="login">
    <div class="login__overlay">
      <div class="login__content">
        <img src="../assets/img/login-logo.svg" alt="Logo" class="login__logo">
        <h2 class="login__title">Проверьте ваш E-mail</h2>
        <p class="login__text">Письмо с ссылкой для восстановления пароля направлено на ваш E-mail. Если не получили, проверьте также в папке “Спам”.</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CheckEmailView',
};
</script>

<style scoped>
.login__overlay {
  background-image: url("../assets/img/signup-bg.png");
  background-position: center;
  background-size: cover;
}

.login__title {
  font-size: 20px;
}
.login__text {
  color: #6F6F6F;
}
</style>